module.exports = __webpack_public_path__ + "static/media/Pin.33ae97e2.svg";